"use client";

import { NewsContext } from "@vereinsheim/backend-types/src/news";
import Link from "next/link";
import { apiGetSmaPath, pwaSocialMediaListPath } from "@/utils/urlHelper";
import { SocialMediaElement } from "./SocialMediaElement";
import {
  SmaListItem,
  SmaListPagination,
  SmaObject,
} from "@/sources/kicker-amateur/types";
import { useState } from "react";
import Button from "../../components/Button";
import { Card } from "../../components/Card";
import ChevronDown from "@/assets/icon/chevron-down.svg";

type SocialMediaListProps = {
  smaObject: SmaObject;
  isShortList?: boolean;
  contextId: string;
  newsContext: NewsContext;
};

export function SocialMediaList({
  smaObject,
  isShortList,
  contextId,
  newsContext,
}: SocialMediaListProps) {
  const [items, setItems] = useState<SmaListItem[]>(
    smaObject?.data ? smaObject.data : []
  );
  const [pagination, setPagination] = useState<SmaListPagination>(
    smaObject?.pagination
  );
  const [showLoadMore, setShowLoadMore] = useState<boolean>(
    smaObject ? smaObject.pagination.page < smaObject.pagination.pages : false
  );
  const [loading, setLoading] = useState(false);

  async function loadMoreItems() {
    setLoading(true);

    const res = await fetch(
      apiGetSmaPath({
        id: contextId,
        type: newsContext.toString().toLowerCase(),
        page: pagination ? (pagination.page + 1).toString() : "0",
        perPage: pagination.per_page.toString(),
      }),
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "GET",
      }
    );
    if (res.ok) {
      const newSmaObject = (await res.json()) as SmaObject;

      setItems([...items, ...newSmaObject.data]);
      setPagination(newSmaObject.pagination);
      setShowLoadMore(
        newSmaObject.pagination.page < newSmaObject.pagination.pages
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  return (
    <div className="px-4">
      {items.length > 0 && (
        <Card p={false}>
          {items.map((n: SmaListItem) => (
            <SocialMediaElement
              item={n}
              className="border-t border-gray-150 pt-4 pb-4 first:border-t-0"
              key={n.id}
            />
          ))}
          {showLoadMore && !isShortList && (
            <div className="mt-4 flex justify-center pb-4">
              <Button
                loading={loading}
                onClick={loadMoreItems}
                className="w-full lg:w-auto justify-center"
              >
                <ChevronDown className="mr-blank" />Mehr Einträge laden
              </Button>
            </div>
          )}
          {/* {isShortList && (
            <div className="border-t border-gray-150">
              <Link
                className="button button--link-secondary w-full justify-center"
                href={pwaSocialMediaListPath()}
              >
                Alle Social Media Einträge
              </Link>
            </div>
          )} */}
        </Card>
      )}
    </div>
  );
}
